import React, {useEffect, useState} from 'react';
import {
  Image,
  ImageSourcePropType,
  ImageStyle,
  Platform,
  StyleProp,
  Text,
} from 'react-native';
import {binaryToBase64} from '../../../common/utils/image';
import api from '../../../services/technique/api';

interface Props {
  url: string;
  style?: StyleProp<ImageStyle>;
}

const DisplayImage: React.FC<Props> = ({url, style = {}}) => {
  const [imageBase64, setImageBase64] = useState('');
  useEffect(() => {
    api
      .get(url, {
        responseType: 'arraybuffer',
      })
      .then(res => {
        const base64 = binaryToBase64(res);
        setImageBase64(() => base64);
      })
      .catch(err => {
        console.log(err);
      });
  }, [url]);

  return imageBase64 ? (
    Platform.OS === 'web' ? (
      <Image source={imageBase64 as ImageSourcePropType} style={style} />
    ) : (
      <Image src={imageBase64} style={style} />
    )
  ) : (
    <Text>Chargement image...</Text>
  );
};

export default DisplayImage;
